/**
 * The application code trying to access `process.env` is a bad practice, as that is NODE concept/feature and not a browser one.
 * Vite makes environment variables available through import meta env https://vitejs.dev/guide/env-and-mode
 * Accessing import meta also isn't a great practice as that can be specific to a build tool.
 * This abstract to configuration variables should make upgrades and migrations easier.
 * Additionally, Vite does not fully support Jest https://jestjs.io/docs/getting-started#using-vite
 * and Jest has poor support for ESM https://jestjs.io/docs/ecmascript-modules
 * This means that `import.meta.env` does not work out of the box for Jest.
 * Having this abstraction layer means that we can get Vite to work and mock this to get Jest to work.
 * Mocking this function / these values in Jest will give us more control and allow us to test a "production" environment.
 */

export const getEnvConfig = () => {
  // FLAGS
  const ENV = import.meta.env.VITE_ENV;
  const HIVEMIND_ENV = import.meta.env.VITE_HIVEMIND_ENV;
  const CY_TEST = import.meta.env.VITE_CY_TEST;
  const JEST = false; // False for unit testing purposes
  const ALLOW_PASSWORD_LOGIN = import.meta.env.VITE_ALLOW_PASSWORD_LOGIN;

  // API SERVICES
  const CURATE_API_V1 = import.meta.env.VITE_CURATE_API_V1;
  const CURATE_API_V2 = import.meta.env.VITE_CURATE_API_V2;
  const INTERACTIVE_EDIT_API = import.meta.env.VITE_INTERACTIVE_EDIT_API;
  const PREDICTION_API = import.meta.env.VITE_PREDICTION_API;
  const SSDI_API = import.meta.env.VITE_SSDI_API;
  const SSDI_API_V2 = import.meta.env.VITE_SSDI_API_V2;
  const STRATEGY_API = import.meta.env.VITE_STRATEGY_API;
  const AGENT_API = import.meta.env.VITE_AGENT_API;
  const FILES_API_HOST = import.meta.env.VITE_FILES_API_HOST;

  // AUTH0
  const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
  const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

  // PUSHER
  const PUSHER_APP_KEY = import.meta.env.VITE_PUSHER_APP_KEY;
  const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER;
  const PUSHER_IE_APP_KEY = import.meta.env.VITE_PUSHER_IE_APP_KEY;
  const PUSHER_IE_CLUSTER = import.meta.env.VITE_PUSHER_IE_CLUSTER;

  // UNLEASH
  const UNLEASH_URL = import.meta.env.VITE_UNLEASH_URL;
  const UNLEASH_TOKEN = import.meta.env.VITE_UNLEASH_TOKEN;
  const UNLEASH_ENV = import.meta.env.VITE_UNLEASH_ENV;

  // OTel
  const OTEL_KEY = import.meta.env.VITE_OTEL_KEY;
  const OTEL_EXPORT_URL = import.meta.env.VITE_OTEL_EXPORT_URL;
  const OTEL_SERVICE_NAME = import.meta.env.VITE_OTEL_SERVICE_NAME;

  // ASSETS
  const PRODUCT_IMAGE_HOST = import.meta.env.VITE_PRODUCT_IMAGE_HOST;
  const AZURE_CDN_DOMAIN = import.meta.env.VITE_AZURE_CDN_DOMAIN;

  return {
    ENV,
    HIVEMIND_ENV,
    CY_TEST,
    JEST,
    ALLOW_PASSWORD_LOGIN,
    CURATE_API_V1,
    CURATE_API_V2,
    INTERACTIVE_EDIT_API,
    PREDICTION_API,
    SSDI_API,
    SSDI_API_V2,
    STRATEGY_API,
    AGENT_API,
    FILES_API_HOST,
    AUTH0_CLIENT_ID,
    AUTH0_DOMAIN,
    AUTH0_AUDIENCE,
    PUSHER_APP_KEY,
    PUSHER_CLUSTER,
    PUSHER_IE_APP_KEY,
    PUSHER_IE_CLUSTER,
    UNLEASH_URL,
    UNLEASH_TOKEN,
    UNLEASH_ENV,
    OTEL_KEY,
    OTEL_EXPORT_URL,
    OTEL_SERVICE_NAME,
    PRODUCT_IMAGE_HOST,
    AZURE_CDN_DOMAIN,
  };
};
